/** 在新标签页安全打开外链 */
export const openExternal = (url?: string | null) => {
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};
